import { render, staticRenderFns } from "./AdminManageRunsPage.vue?vue&type=template&id=1099791a"
import script from "./AdminManageRunsPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./AdminManageRunsPage.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports